<template lang="pug">
	div
		template(v-if="isLoading")
			.loading

				template(v-if="type === 'text'")
					small.text--color_grey.text-uppercase(style="letter-spacing: 3px;") Loading Data...
				
				template(v-if="type === 'bar'")
					.loading--bar
					.loading--bar
					.loading--bar
					
			
		template(v-else)
			slot

</template>



<script>
	export default  {
		props: {
	    isLoading: {
	      type: Boolean,
	      default: true,
	    },
	    type: {
	    	type: String,
	    	default: 'bar'
	    }
		},

	  data() {
	    return {

	    }
	  },


	  computed: {

	  },


	  methods: {

	  },


	  created() {

	  }
	}
</script>




<style lang="scss" scoped>
	.loading {
		margin: 3% 0 2%;
		padding: 0;
	}

@keyframes placeHolderShimmer{
    0%{
        background-position: -1000px 0
    }
    100%{
        background-position: 1000px 0
    }
}

.loading--bar {
  animation-duration: 1.25s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: placeHolderShimmer;
  animation-timing-function: linear;
  background: #F6F6F6;
  background: linear-gradient(to right, #eeeeee 8%, #dddddd 18%, #eeeeee 33%);
  background-size: 100% 104px;
  position: relative;

  width: 100%;
  height: 0;
  padding-bottom: 1.5%;

  + .loading--bar {
  	margin-top: 1.5%;
  }
}
</style>